import React from "react";

const ArrowLeft = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path
        d="M15.8203 18.4188L15.8203 6.57877C15.8203 5.61877 14.6603 5.13877 13.9803 5.81877L8.80031 10.9988C7.97031 11.8288 7.97031 13.1788 8.80031 14.0088L10.7703 15.9788L13.9803 19.1888C14.6603 19.8588 15.8203 19.3788 15.8203 18.4188Z"
        fill="#BF1D2D"
      />
    </svg>
  );
};

export default ArrowLeft;
